import { BaseNavigationItem as NavigationItem } from '@ui/shared/model';
import { Icons } from '@ui/shared/model';

// TODO: remove
export const messengerNavigation: NavigationItem = {
  name: 'messenger',
  label: 'navigation.messenger_l',
  link: '/messenger',
  icon: Icons.Messenger
};
